import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useRouter } from 'next/router';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getPosts, getPostsRelated } from '../../redux/actions/news';
import useTrans from '../../hooks/useTrans';
import Head from 'next/head';
import Device from '../Device';
import MetaSeo from '../MetaSeo';
import dynamic from 'next/dynamic';

export default function detail(props) {
  const dispatch = useDispatch();
  const [post_category, setPostCategory] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [share, setShare] = useState();
  const [openFaq, setOpenFaq] = useState(null);
  const router = useRouter();
  const trans = useTrans();
  const { news } = useSelector(state => {
    return {
      news: state.news.news,
    };
  }, shallowEqual);
  useEffect(() => {
    if (props.postcategory) {
      getPostCategory();
    }
    setPage(1);
  }, [dispatch, props]);

  useEffect(() => {
    setShare(
      process.env.NEXT_PUBLIC_WEB_URL ||
        window.location.origin + window.location.pathname,
    );
  }, []);
  const getPostCategory = async () => {
    const data = await getPostsRelated(
      { category_id: props.postcategory.id, id: props.id, limit: 3 },
      dispatch,
    );
    if (data) {
      setPostCategory(data.rows);
      setTotal(data.total);
    }
  };
  const loadMore = async () => {
    let new_page = parseInt(page) + 1;
    setPage(new_page);
    const data = await getPosts(
      {
        page: new_page,
        limit: 3,
        category_id: props.postcategory.id,
        id: props.id,
      },
      dispatch,
    );
    if (data) {
      const new_data = [...post_category, ...data.rows];
      setPostCategory(new_data);
    }
  };
  const filterTag = async tag_name => {
    let new_search = `#${tag_name}`;
    setSearch(new_search);
    const data = await getPosts(
      {
        name: new_search,
        page: 1,
        category_id: props.postcategory.id,
        id: props.id,
      },
      dispatch,
    );
    setPage(1);
    setTotal(data.total);
    setPostCategory(data.rows);
  };

  const defaultConfigs = {
    header: {
      textAlign: 'left',
    },
    image: {
      img: {},
      figure: {
        backgroundColor: 'aliceblue',
        border: '1px solid #eee',
      },
      figcaption: {
        borderRadius: '5px',
      },
    },
    video: {
      video: {},
      figure: {
        backgroundColor: 'aliceblue',
        border: '1px solid #eee',
      },
      figcaption: {
        borderRadius: '5px',
      },
    },
    embed: {
      video: {},
      figure: {
        justifyContent: 'center',
      },
      figcaption: {
        borderRadius: '5px',
      },
    },
    paragraph: {
      textAlign: 'left',
      cursor: 'default',
    },
    list: {
      textAlign: 'left',
    },
    checklist: {
      container: {},
      item: {},
      checkbox: {},
      label: {},
    },
    table: {
      table: {},
      tr: {},
      th: {},
      td: {},
    },
    quote: {
      container: {},
      content: {},
      author: {
        fontWeight: 'bold',
      },
      message: {
        textAlign: 'left',
      },
    },
    codeBox: {
      container: {
        width: '100%',
      },
      code: {
        boxSizing: 'border-box',
      },
    },
    warning: {
      container: {
        width: '100%',
      },
      icon: {
        width: '30px',
      },
      title: {
        fontWeight: 500,
      },
      message: {
        fontSize: '14px',
      },
    },
    delimiter: {
      container: {},
      svg: {},
      path: {
        fill: '#231F20',
      },
    },
  };
  let faqs = props.faqs;
  if (typeof faqs === 'string') {
    try {
      faqs = JSON.parse(faqs);
    } catch (error) {
      faqs = [];
    }
  }
  const dataSeo = {
    url: `https://eyefire.vn/news/${props.seo_url}`,
    type: 'website',
    title: `${props.title} | EYEFIRE`,
    description: props.seo_description || 'EYEFIRE',
    image: props.image,
    domain: 'eyefire.vn',
    card: 'summary_large_image',
  };
  return (
    <>
      <MetaSeo {...dataSeo} />
      <section id="news-detail" className="p-news-details">
        <div className="l-container">
          <div className="l-row">
            <div
              className={`l-col ${
                post_category.length ? 'l-col-8' : 'l-col-12'
              } p-news-details__main`}
            >
              <div className="p-news-details__btn-back">
                <a onClick={() => router.back()}>
                  <img src="/assets/img/news-details/icn_back.svg" alt="" />
                  <span>{ trans.text_button.back}</span>
                </a>
              </div>
              <h3 className="p-news-details__title">{props.title}</h3>
              <div className="p-news-details__category">
                {props?.postcategory?.name}
              </div>
              <div className="p-news-details__time">
                <img src="/assets/img/news-details/icn_calendar.svg" alt="" />
                <span>
                  {' '}
                  {moment(props?.show_date || props?.createdAt).format(
                    'DD/MM/YYYY',
                  )}
                </span>
              </div>
              <div className="post">
                <div dangerouslySetInnerHTML={{ __html: props.html_content }} />
                <div className="author">Biên tâp: Eyefire</div>
              </div>
              {Array.isArray(faqs) && faqs.length ? (
                <div className="p-news-details__faqs">
                  <h2 className="p-news-details__faqs-title">
                    Câu hỏi thường gặp
                  </h2>
                  <div className="p-news-details__faqs-list">
                    {faqs.map((item, index) => (
                      <div
                        key={index}
                        className={`p-news-details__faq-item ${
                          openFaq === index ? 'active' : ''
                        }`}
                      >
                        <div
                          className="p-news-details__faq-question"
                          onClick={() =>
                            setOpenFaq(openFaq === index ? null : index)
                          }
                        >
                          <span>{item.question}</span>
                          <span className="p-news-details__faq-icon" />
                        </div>
                        <div className="p-news-details__faq-answer">
                          <div
                            dangerouslySetInnerHTML={{ __html: item.answer }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
            {post_category.length ? (
              <div className="l-col l-col-4 p-news-details__sidebar">
                <h3 className="p-news-details__title">{trans.news.relate}</h3>
                <div className="p-news-details__related">
                  {post_category.map((item, index) => (
                    <a
                      href={`/${router.locale}/news/${item.seo_url}`}
                      className="p-news-details__related-item"
                    >
                      <div className="p-news-details__related-info">
                        <h5>{item.title}</h5>
                        <div
                          className="p-news-details__related-group"
                          style={{ display: 'flex' }}
                        >
                          <div className="p-news-details__related-time">
                            {item?.postcategory?.name}
                          </div>
                          <div className="p-news-details__related-time">
                            <img src="/static/Ellipse 627.png" alt="" />
                            <span>
                              {moment(
                                item?.show_date || item?.createdAt,
                              ).format('DD/MM/YYYY')}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="p-news-details__related-img">
                        <img className="w-100" src={item.image} alt="" />
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </section>
    </>
  );
}
